import Snackbar from './Snackbar.vue'

const SnackbarPlugin = {

	install(Vue, defaults = {}) {
		const CONSTRUCTOR = Vue.extend(Snackbar)
		const CACHE = {}

		function snackbar(msg, options = {}) {
			options.message = msg
			const snackbar = CACHE[options.id] || (CACHE[options.id] = new CONSTRUCTOR())
			if (!snackbar.$el) {
				const vm = snackbar.$mount()
				document.querySelector(options.parent || 'body').appendChild(vm.$el)
			}
			snackbar.queue.push(options)
		}

		Vue.snackbar = Vue.prototype.$snackbar = snackbar
	}
}

if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(SnackbarPlugin)
}

export default SnackbarPlugin



// WEBPACK FOOTER //
// ./src/lib/snackbar/index.js